import {
  SET_BATCHES,
  //SET_BATCHES_LOADING,
  //RESET_BATCHES,
  //SET_CATEGORY_PRODUCT_BATCH,
  SET_BATCH_QUANTITIES,
  //SET_EXCISE_TAX,
  //SET_RECONCILIATION_BATCHES,
  //SET_RECONCILIATION_BATCHES_VALUES,
  //SET_METRC_BATCHES,
  //FETCHING_METRC_BATCHES
} from '../types/batch'

const initState = {
  batches: [],
  loading: false,
  product_batches: {},
  inventory_batches: [],
  perUnitExciseTax: 0,
  reconcileBatch: {},
  reconcileBatchesValues: {},
  metrcBatches: {},
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_BATCHES:
      return { ...state, batches: action.payload }
    // case SET_BATCHES_LOADING:
    //     return  {...state, loading: action.payload};
    // case RESET_BATCHES:
    //     return  {state:initState};
    // case SET_CATEGORY_PRODUCT_BATCH:
    //     return {...state,
    //     product_batches:{
    //     ...state.product_batches,
    //     [action.payload.product]:[].concat(action.payload.batches)
    //     }}
    case SET_BATCH_QUANTITIES:
      return { ...state, inventory_batches: action.payload.batches }
    // case SET_EXCISE_TAX:
    //     return {...state, perUnitExciseTax: action.payload}
    // case SET_RECONCILIATION_BATCHES:
    //     return {...state, reconcileBatch: action.payload}
    // case SET_RECONCILIATION_BATCHES_VALUES:
    //     return {...state, reconcileBatchesValues: action.payload}
    // case SET_METRC_BATCHES:
    //     return {...state, metrcBatches: action.payload}
    // case FETCHING_METRC_BATCHES:
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/batch.js